<template>
  <!-- banner-page -->
  <BannerPageComponent />
  <!-- /banner-page -->


  <!-- page-menu3-wrap -->
  <MenuItemsComponent />
  <!-- /page-menu3-wrap -->

</template>

<script>
import BannerPageComponent from './BannerPageComponent.vue';
import MenuItemsComponent from './MenuItemsComponent.vue';

export default {
  name: "MenuComponent",
  components: {
    BannerPageComponent,
    MenuItemsComponent
  },
};
</script>

<style>
/* Add your CSS styles here */
</style>
